module.exports = __webpack_public_path__ + "static/img/operaingCostc.47e9cb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/operaingCostc.png
// module id = 6m5C
// module chunks = 1